import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import styles from '../../sass/orderDetails.module.scss'
import { HiOutlinePrinter, HiOutlineDotsVertical, HiOutlineChatAlt2, HiOutlineXCircle  } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCurrentOrderDetails, addOrderCourier, updateOrderCourier, updateOrderDetails } from '../../redux/actions/orderActions'
import { BASE_URL } from '../../constant'
import CustomDropdown from '../../components/CustomDropdown'
import ReactQuill from 'react-quill'
import Modal from 'react-modal'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import { format } from 'date-fns'
import { toast } from 'react-toastify'
import Slider from 'react-slick'
import { BiCopy, BiEditAlt } from 'react-icons/bi'
import copy from 'copy-to-clipboard'


const OrderDetails = () => {
  const { orderNumber, id } = useParams();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.admin);
  const { currentOrder, loader } = useSelector((state) => state.orders);
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const [paymentMode, setPaymentMode] = useState("COD");
  const [paymentMethod, setPaymentMethod] = useState("Debit Card");
  const [paymentStatus, setPaymentStatus] = useState("Captured");

  useEffect(() => {
    if (currentOrder?.data?.order) {
      setPaymentMode(currentOrder.data.order.payment_type);
      setPaymentMethod(currentOrder.data.order.payment_method);
      setPaymentStatus(currentOrder.data.order.payment_status);
    }
  }, [currentOrder?.data?.order]); // <--- triggers when currentOrder changes

  const ALL_STATUSES = [
    'Processing',
    'On hold',
    'Dispatched',
    'Partial Dispatch',
    'Completed',
    'Waiting for goods',
    'RTO',
    'Canceled',
  ];
  
  
  const [timeline, setTimeline] = useState([]);
  const [oStatus, setOStatus] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Initialize timeline with “Order Placed” (with time) + current status (no time)
  useEffect(() => {
    if (!currentOrder?.data?.order) return;

    const placedTime = format(
      new Date(currentOrder.data.order.created_at),
      'd/M/yyyy, h:mm:ss a'
    );

    setTimeline([
      { status: 'Order Placed', time: placedTime },
      { status: currentOrder.data.order.status },
    ]);
    setOStatus(currentOrder.data.order.status)
  }, [currentOrder]);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    window.addEventListener('mousedown', handleClickOutside);
    return () => window.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentStatus = timeline.length
    ? timeline[timeline.length - 1].status
    : null;

  const availableStatuses = ALL_STATUSES.filter(s => s !== currentStatus);

  function handleSelect(newStatus) {
    // Only update the second slot (index 1)
    setTimeline(([first]) => [
      first,
      { status: newStatus },
    ]);
    setDropdownOpen(false);
    setOStatus(newStatus)
    // TODO: persist change to your backend
  }

  console.log("current status of order:", oStatus)

  const [addNote, setAddNote] = useState('');
  const [remark, setRemark] = useState('');
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],  
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'], 
    ],
  };
  
  const [modalIsOpen, setIsOpen] = useState(false);
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: '2rem',
      borderRadius: '16px',
      backgroundColor: '#fff',
      boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
      width: '90%',
      maxWidth: '500px',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
  };
  const onAddNew = () => {
    setFormData({
      courier_id: '',
      payment_via: 'Prepaid',
      amount: '',
      tracking_no: '',
      tracking_link: '',
      estimated_delivery_date: '',
      specific_date: '',
      courier_status: '',
    });
    
    setIsEditing(false);
    setEditCourierId(null);
    setIsOpen(true);
  }

  const [selected, setSelected] = useState(null);
  const selectCustomStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      borderColor: '#E6EBF4',
      boxShadow: 'none',
      padding: '5px',
      ':hover': {
        borderColor: '#DCE4F1',
        cursor: 'pointer'
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? '#10847E'
        : state.isFocused
        ? 'rgba(16,132,126,0.05)'
        : 'white',
      color: state.isSelected ? 'white' : 'black',
      padding: 10,
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '10px',
      overflow: 'hidden',
      width: 'calc(100% - 1px)',
      marginLeft: '2px',
      marginRight: 'auto',
      padding: '5px',
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    singleValue: (base) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      height: 0,           // 👈 THIS FIXES IT
      overflow: 'hidden',  // 👈 AND THIS
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '40px',
    }),
  };
  

  // Custom Option Renderer
  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', fontSize: 14, fontWeight: 700 }}>
        <img src={BASE_URL + data.logo} alt={data.slug} style={{ width: 35, height: 35, objectFit: 'contain', marginRight: 12 }} />
        <span>{data.name}</span>
      </div>
    );
  };

  // Custom Single Value Renderer
  const CustomSingleValue = ({ data }) => (
    <div style={{ display: 'flex', alignItems: 'center', fontSize: 14, fontWeight: 700 }}>
      <img src={BASE_URL + data.logo} alt={data.slug} style={{ width: 35, height: 35, objectFit: 'contain', marginRight: 12}} />
      <span>{data.name}</span>
    </div>
  );

  
  const courierOptions = currentOrder?.data?.courierStatus?.map(item => ({
    value: item,
    label: item
  })) || [];
  
  const [selectedCourierStatus, setSelectedCourierStatus] = useState(null);

  const [esDate, setESDate] = useState(new Date());
  const [specificDate, setSpecificDate] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [editCourierId, setEditCourierId] = useState(null);

  const [formData, setFormData] = useState({
    courier_id: '',
    payment_via: 'Prepaid',
    amount: '',
    tracking_no: '',
    tracking_link: '',
    estimated_delivery_date: '',
    specific_date: '',
    courier_status: '',
  });

  const [copied, setCopied] = useState(false);

  const handleCopy = (link) => {
    const success = copy(link); // Returns true if copied
    if (success) {
      setCopied(true);
      toast.info('Copied!');
      setTimeout(() => setCopied(false), 2000);
    }
  };
  
  useEffect(() => {
    if (token && orderNumber && id) {
      dispatch(fetchCurrentOrderDetails({ token, orderNumber, id }));
    }
  }, [dispatch, token, orderNumber, id]);

  useEffect(() => {
    setAddNote(currentOrder?.data?.order?.add_note); // remark is an HTML string
    setRemark(currentOrder?.data?.order?.remark); // remark is an HTML string
  }, [currentOrder?.data?.order]);

  const myOrder = currentOrder?.data.order;

  // Safely return nothing or a loader if data isn't available yet
  if (loader || !myOrder) {
    return <div>Loading order details...</div>;
  }

  const createdAt = new Date(myOrder.created_at);

 

  // Format date: Sun, Apr 6, 2025
  const formattedDate = createdAt.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  // Format time: 06:33 PM
  const formattedTime = createdAt.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const parsedAddress = JSON.parse(myOrder.address);
  const productList = myOrder.products ? JSON.parse(myOrder.products) : [];
  // console.log(JSON.stringify(productList,0,2))

  console.log("Current Order Details:", JSON.stringify(myOrder, 0, 2));

  const handleEdit = (courier) => {
      setFormData({
        courier_id: courier.courier_id,
        payment_via: courier.payment_via,
        amount: courier.amount,
        tracking_no: courier.tracking_no,
        tracking_link: courier.tracking_link,
        estimated_delivery_date: courier.estimated_delivery_date,
        courier_status: courier.courier_status,
        specific_date: courier.specific_date,
      });
      setEditCourierId(courier.id);
      setIsEditing(true);
      setIsOpen(true);
  };

  const handleSubmit = () => {
    // console.log("Final form data: ", formData);
    const data = new FormData();
    data.append('courier_id', formData.courier_id); // assuming formData has name, website, etc.
    data.append('payment_via', formData.payment_via || '');
    data.append('amount', formData.amount || '');
    data.append('tracking_no', formData.tracking_no || '');
    data.append('tracking_link', formData.tracking_link || '');
    data.append('estimated_delivery_date', formData.estimated_delivery_date || '');
    data.append('courier_status', formData.courier_status || '');
    data.append('specific_date', formData.specific_date || '');

    if (isEditing) { 
      dispatch(updateOrderCourier({ token, data, id: editCourierId }))
        .unwrap()
        .then(() => {
          toast.success('Updated successfully!');
          dispatch(fetchCurrentOrderDetails({ token, orderNumber, id }))
          setIsOpen(false);
          setIsEditing(false);
          setEditCourierId(null);
        })
        .catch((error) => {
          toast.error('Failed to updated courier details. Please try again.');
          if (error.errors && typeof error.errors === 'object') {
            const errorMessages = Object.values(error.errors).flat(); 
            setError(errorMessages);
          } else {
              setError(error.message || 'Failed to updated courier details. Please try again.');
          }
        });
    } else {
      dispatch(addOrderCourier({ token, data, id }))
        .unwrap()
        .then(() => {
          toast.success('Added successfully!');
          setIsOpen(false);
        })
        .catch((error) => {
          toast.error('Failed to add courier details. Please try again.');
          if (error.errors && typeof error.errors === 'object') {
            const errorMessages = Object.values(error.errors).flat(); 
            setError(errorMessages);
          } else {
              setError(error.message || 'Failed to add courier details. Please try again.');
          }
        });
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    variableWidth: true,
  };
  

  const handleUpdateOrder = () => {
    const data = new FormData();
    data.append('add_note', addNote);
    data.append('remark', remark);
    data.append('payment_type', paymentMode);
    data.append('payment_method', paymentMethod);
    data.append('payment_status', paymentStatus);
    data.append('status', oStatus);

    dispatch(updateOrderDetails({ token, data, orderNumber, id }))
        .unwrap()
        .then(() => {
          toast.success('Updated successfully!');
          dispatch(fetchCurrentOrderDetails({ token, orderNumber, id }));
        })
        .catch((error) => {
          toast.error('Failed to update details. Please try again.');
          if (error.errors && typeof error.errors === 'object') {
            const errorMessages = Object.values(error.errors).flat(); 
            setError(errorMessages);
          } else {
              setError(error.message || 'Failed to update details. Please try again.');
          }
        });
  }

 
  
  return (
    <>
      <div className={styles.OrderDetails_Container}>
          <div className={styles.OrderDetails_headerWrapper}>
            <div className={styles.OrderDetails_headerWrapper_LHS_wrapper}>
              <div className={styles.OrderNumber}>Order Number #{myOrder.po_number}</div>
              <div className={styles.orderCreated_wrapper}>
                <span className={styles.orderCreated}>Order Created</span>
                <span className={styles.orderDate}>{formattedDate}</span>
                <span className={styles.orderDate}>{formattedTime}</span>
              </div>
            </div>
            <div className={styles.OrderDetails_headerWrapper_RHS_wrapper}>
              <div className={styles.iconWrapper}>
                <HiOutlinePrinter />
              </div>
              <div className={styles.iconWrapper}>
                <HiOutlineDotsVertical />
              </div>
            </div>
          </div>

          <div className={styles.OrderDetails_mainContainer_grid}>
            <div className={styles.Details}>
              <div className={styles.Details_headerWrapper}>
                <p className={styles.Details_headerTitle}>Customer Details</p>
                <div className={styles.iconWrapper}>
                  <HiOutlineChatAlt2  />
                </div>
              </div>
              <div className={styles.Details_contentWrapper}>
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Name</span>
                  <span className={styles.Details_contentWrapper_Item_details}>{parsedAddress.fname} {parsedAddress.lname}</span>
                </div>
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Email</span>
                  <span className={styles.Details_contentWrapper_Item_details}>{myOrder.email}</span>
                </div>
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Mobile</span>
                  <span className={styles.Details_contentWrapper_Item_details}>+91 {parsedAddress.phone}</span>
                </div>
              </div>
            </div>

            <div className={styles.Details}>
              <div className={styles.Details_headerWrapper}>
                <p className={styles.Details_headerTitle}>Delivery Address</p>
                <div className={styles.iconWrapper}>
                  <HiOutlinePrinter  />
                </div>
              </div>
              <div className={styles.Details_contentWrapper}>
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Address</span>
                  <span className={styles.Details_contentWrapper_Item_details}>
                    {parsedAddress.address}, {parsedAddress.city}, {parsedAddress.state_name} - {parsedAddress.pincode}, {parsedAddress.country_name}.
                  </span>
                </div>
                {parsedAddress.landmark !== null && (
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Landmark</span>
                  <span className={styles.Details_contentWrapper_Item_details}>{parsedAddress.landmark}</span>
                </div>
                )}
                {parsedAddress.gstin !== null && (
                  <div className={styles.Details_contentWrapper_Item}>
                    <span className={styles.Details_contentWrapper_Item_title}>GSTIN</span>
                    <span className={styles.Details_contentWrapper_Item_details}>{parsedAddress.gstin}</span>
                  </div>
                )}
                {parsedAddress.dla !== null && (
                  <div className={styles.Details_contentWrapper_Item}>
                    <span className={styles.Details_contentWrapper_Item_title}>Drug Licence</span>
                    <span className={styles.Details_contentWrapper_Item_details}>{parsedAddress.dla}</span>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.Details}>
              <div className={styles.Details_headerWrapper}>
                <p className={styles.Details_headerTitle}>Order History</p>
                
                <div className={styles.iconWrapper} onClick={() => setDropdownOpen(o => !o)}>
                  <HiOutlineDotsVertical />
                  {dropdownOpen && (
                    <div className={styles.dropdown} ref={dropdownRef}>
                      {availableStatuses.map(status => (
                        <div
                          key={status}
                          className={styles.dropdownItem}
                          onClick={() => handleSelect(status)}
                        >
                          {status}
                        </div>
                    ))}
                  </div>
                )}
                </div>
              </div>

              <div className={styles.timeline}>
                {timeline.map((item, idx) => (
                  <div
                    key={idx}
                    className={`${styles.timelineItem} ${idx === timeline.length - 1 ? styles.active : ""} ${
                      timeline.find(t => t.status === "Canceled") ? styles.canceled : ""
                    }`}
                  >
                    <div className={styles.timelineDot} />
                    <div className={styles.timelineContent}>
                      <p className={styles.status}>{item.status}</p>
                      <p className={styles.time}>{item.time}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>


            <div className={`${styles.Details} ${styles.orderDetailsTable}`}>
              <table>
                <thead>
                  <tr>
                    <th>Item Summary</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {productList.map((product) => (
                    <tr key={product.id}>
                      <td>
                        <div className={styles.productItem}>
                          <img src={ BASE_URL + product.image} alt={product.name}/> 
                          {product.name}
                        </div>
                      </td>
                      <td>x{product.quantity}</td>
                      <td>₹{product.offer_price}</td>
                      <td>₹{product.offer_price * product.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {myOrder.note !== null && (
                <div className={styles.userNote_wrapper}>
                    <p className={styles.userNote_title}>Customer Note:</p>
                    <div className={styles.userNote_content}>
                      {myOrder.note}
                    </div>
                </div>
              )}
            </div>

            <div className={`${styles.Details} ${styles.OrderSummaryDetails}`}>
              <div className={styles.Details_headerWrapper}>
                <p className={styles.Details_headerTitle}>Order Summary</p>
              </div>
              <div className={styles.Details_contentWrapper}>
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>You saved</span>
                  <span className={styles.Details_contentWrapper_Item_details}>₹{myOrder.discountedTotal}</span>
                </div>
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Delivery Charges</span>
                  <span className={styles.Details_contentWrapper_Item_details}>₹{myOrder.delivery_charges}</span>
                </div>
                {myOrder.payment_type !== 'Online' && (
                  <div className={styles.Details_contentWrapper_Item}>
                    <span className={styles.Details_contentWrapper_Item_title}>Cash on Delivery</span>
                    <span className={styles.Details_contentWrapper_Item_details}>₹{myOrder.cod_amt}</span>
                  </div>
                )}
                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Total Bill</span>
                  <span className={styles.Details_contentWrapper_Item_details}><strong>₹{myOrder.total}</strong></span>
                </div>

                <div className={styles.hr}></div>

                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Payment Mode</span>
                  <CustomDropdown
                    label="Payment Mode"
                    options={["Online", "COD"]}
                    selected={paymentMode}
                    onChange={setPaymentMode}
                  />
                </div>

                {myOrder.payment_id !== null && (
                  <div className={styles.Details_contentWrapper_Item}>
                    <span className={styles.Details_contentWrapper_Item_title}>Payment id</span>
                    <span className={styles.Details_contentWrapper_Item_details}>{myOrder.payment_id}</span>
                  </div>
                )}


                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Payment Method</span>
                  <CustomDropdown
                    label="Payment Method"
                    options={["UPI", "Net Banking", "Credit Card", "Debit Card", "Wallet", "COD"]}
                    selected={paymentMethod}
                    onChange={setPaymentMethod}
                  />
                </div>

                <div className={styles.Details_contentWrapper_Item}>
                  <span className={styles.Details_contentWrapper_Item_title}>Payment Status</span>
                  <CustomDropdown
                    label="Payment Status"
                    options={["Captured", "Pending", "Refund", "Failed"]}
                    selected={paymentStatus}
                    onChange={setPaymentStatus}
                  />
                </div>
                
              </div>
            </div>

           

            <div className={`${styles.Details} ${styles.courierWrapper}`}>
              <div className={styles.Details_headerWrapper}>
                <p className={styles.Details_headerTitle}>Courier Details <div className={styles.courierAddBtn} onClick={() => onAddNew()}>+Add</div></p>
              </div>
              <div className={styles.Details_contentWrapper}>
                {currentOrder?.data?.courierDetails?.length > 0 ? (
                  <Slider {...settings}>
                    { currentOrder?.data?.courierDetails?.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          width: 320, // or any fixed px value you want
                          marginRight: 16, // creates space between slides
                          boxSizing: "border-box",
                        }}
                      >
                        <div className={styles.courierItemDetails_wrapper}>
                          <div className={styles.courierItemDetails_imgBox}>
                            <img src={ BASE_URL + item.logo} alt={item.slug} />
                          </div>
                          
                          <div className={styles.Details_contentWrapper}>
                            <div className={styles.Details_contentWrapper_Item}>
                              <span className={styles.Details_contentWrapper_Item_title}>Payment via</span>
                              <span className={styles.Details_contentWrapper_Item_details}>{item.payment_via}</span>
                            </div>
                            <div className={styles.Details_contentWrapper_Item}>
                              <span className={styles.Details_contentWrapper_Item_title}>Amount</span>
                              <span className={styles.Details_contentWrapper_Item_details}>INR {item.amount}</span>
                            </div>
                            <div className={styles.Details_contentWrapper_Item}>
                              <span className={styles.Details_contentWrapper_Item_title}>Tracking number</span>
                              <span className={styles.Details_contentWrapper_Item_details}>{item.tracking_no}</span>
                            </div>
                            <div className={`${styles.Details_contentWrapper_Item}`}>
                              <span className={styles.Details_contentWrapper_Item_title}>Tracking link</span>
                              <span className={`${styles.Details_contentWrapper_Item_details} ${styles.copied}`} onClick={() => handleCopy(item.tracking_link)}>Copy link <BiCopy style={{ cursor: "pointer", marginLeft: "8px" }} /> </span>
                            </div>
                            <div className={styles.Details_contentWrapper_Item}>
                              <span className={styles.Details_contentWrapper_Item_title}>Estimated delivery date</span>
                              <span className={styles.Details_contentWrapper_Item_details}>{item.estimated_delivery_date}</span>
                            </div>
                            <div className={styles.Details_contentWrapper_Item}>
                              <span className={styles.Details_contentWrapper_Item_title}>Courier status</span>
                              <span className={styles.Details_contentWrapper_Item_details}>{item.courier_status}</span>
                            </div>
                            <div className={styles.Details_contentWrapper_Item}>
                              <span className={styles.Details_contentWrapper_Item_title}></span>
                              <span className={styles.Details_contentWrapper_Item_details}><div className={`${styles.courierAddBtn} ${styles.courierEditBtn}`} onClick={() => handleEdit(item)}><BiEditAlt /> Edit</div></span>
                            </div>
                          </div>

                        </div>
                      </div>
                    )) }
                  </Slider>
                ) : (
                  <small>No couriers added. Please add courier details to proceed.</small>
                )}
              </div>

              <div className={styles.orderShortNote_wrapper}>
                <div className={`${styles.editorBlock}`}>
                  <div className={styles.Details_headerWrapper}>
                    <p className={styles.Details_headerTitle}>Add a note</p>
                  </div>

                  <div className={styles.Details_contentWrapper}>
                    <ReactQuill theme="bubble" value={addNote} onChange={setAddNote} 
                      placeholder="Start writing here..."
                      className={styles.EditorWrapper}
                      modules={modules}
                    />
                  </div>
                </div>

                <div className={`${styles.remarkBlock}`}>
                  <div className={styles.Details_headerWrapper}>
                    <p className={styles.Details_headerTitle}>Remark</p>
                  </div>

                  <div className={styles.Details_contentWrapper}>
                    <ReactQuill theme="bubble" value={remark} onChange={setRemark} 
                      placeholder="Start writing here..."
                      className={styles.EditorWrapper}
                      modules={modules}
                    />
                  </div>
                </div>
              </div>

              <div className={`divBtn ${styles.orderBtn}`} onClick={() => handleUpdateOrder()}>Update order</div>

            </div>
          </div>
      </div>

      <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => {
              setIsOpen(false);
              setIsEditing(false);
              setEditCourierId(null);
            }}
            contentLabel="Courier Modal"
            style={customStyles}
        >
            <div className='formModal_container'>
                <div className='formModal_heading_wrapper'>
                    <span className='title'>{isEditing ? 'Update details' : 'Add details'}</span>
                    <HiOutlineXCircle 
                      className='close' 
                      onClick={() => {
                        setIsOpen(false);
                        setIsEditing(false);
                        setEditCourierId(null);
                      }} 
                    />
                </div>

                <div className='formModal_content_wrapper'>
                  {error && (
                    <div className='errorsBlock'>
                        {Array.isArray(error)
                        ? error.map((errMsg, index) => <div key={index}>{errMsg}</div>)
                        : error}
                    </div>
                  )}

                  <div className='formGroup'>
                    <label className='formGroup_label'>Courier <span>*</span></label>
                    <Select
                      options={currentOrder?.data.couriers}
                      value={currentOrder?.data.couriers.find(courier => courier.id === formData.courier_id) || null}
                      name='courier_id'
                      onChange={(option) => {
                        setSelected(option);
                        setFormData({ ...formData, courier_id: option?.id || '' });
                      }}
                      components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
                      placeholder="Select a courier"
                      styles={selectCustomStyles}
                      filterOption={(option, inputValue) =>
                        option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                      }
                    />
                    {/* <input type="hidden" name="courier_id" value={selected?.id || ''} /> */}
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Payment via <span>*</span></label>
                    <div className="payment-radio-group">
                      <label className={`radio-option ${formData.payment_via === 'Prepaid' ? 'selected' : ''}`}>
                        <input
                          type="radio"
                          name="payment_via"
                          value="Prepaid"
                          checked={formData.payment_via === 'Prepaid'}
                          onChange={(e) => setFormData({ ...formData, payment_via: e.target.value })}
                        />
                        <span className="custom-radio" />
                        Prepaid
                      </label>

                      <label className={`radio-option ${formData.payment_via === 'COD' ? 'selected' : ''}`}>
                        <input
                          type="radio"
                          name="payment_via"
                          value="COD"
                          checked={formData.payment_via === 'COD'}
                          onChange={(e) => setFormData({ ...formData, payment_via: e.target.value })}
                        />
                        <span className="custom-radio" />
                        Cash on Delivery
                      </label>
                    </div>
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Amount <span>*</span></label>
                    <input
                        type="text"
                        name="amount"
                        className='formGroup_input'
                        placeholder='Enter value'
                        value={formData.amount}
                        onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                        required
                    />
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Tracking number <span>*</span></label>
                    <input
                        type="text"
                        name="tracking_no"
                        className='formGroup_input'
                        placeholder='Enter value'
                        value={formData.tracking_no}
                        onChange={(e) => setFormData({ ...formData, tracking_no: e.target.value })}
                        required
                    />
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Tracking link <span>*</span></label>
                    <input
                        type="text"
                        name="tracking_link"
                        className='formGroup_input'
                        placeholder='Enter value'
                        value={formData.tracking_link}
                        onChange={(e) => setFormData({ ...formData, tracking_link: e.target.value })}
                        required
                    />
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Estimated delivery date</label>
                    <DatePicker
                      selected={esDate}
                      value={formData.estimated_delivery_date}
                      onChange={(date) => {
                        setESDate(date);
                        setFormData({ ...formData, estimated_delivery_date: date?.toISOString().split('T')[0] || '' });
                      }}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                      className="custom-datepicker"
                      popperPlacement="bottom-start"
                    />
                    {/* <input type="hidden" name="estimated_delivery_date" value={esDate.toISOString().split('T')[0]} /> */}
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Courier status <span>*</span></label>
                    <Select
                      name="courier_status"
                      options={courierOptions}
                      value={courierOptions.find(option => option.value === formData.courier_status) || null}
                      onChange={(option) => {
                        setSelectedCourierStatus(option);
                        setFormData({ ...formData, courier_status: option?.value || '' });
                      }}
                      styles={selectCustomStyles}
                      classNamePrefix="react-select"
                      // menuPortalTarget={document.body}
                      placeholder="Select courier status"
                    />
                    {/* <input type="hidden" name="courier_status" value={selectedCourierStatus?.value || ''} /> */}
                  </div>

                  <div className='formGroup'>
                    <label className='formGroup_label'>Specific date <small>(Optional)</small></label>
                    <DatePicker
                      selected={specificDate}
                      onChange={(date) => {
                        setSpecificDate(date)
                        setFormData({ ...formData, specific_date: format(date, 'yyyy-MM-dd') || '' });
                      }}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                      className="custom-datepicker"
                      popperPlacement="bottom-start"
                    />
                    {/* <input type="hidden" name="specific_date" value={specificDate ? format(specificDate, 'yyyy-MM-dd') : ''} /> */}
                  </div>
                </div>
                <div
                    className='divBtn'
                    style={{ width: 'fit-content', marginTop: 20, marginLeft: 'auto' }}
                    onClick={handleSubmit}
                >
                  
                  {isEditing ? 'Update' : '+ Save Details'}
                </div>
                
            </div>
      </Modal>
    </>
  )
}

export default OrderDetails 